import { Controller, useFieldArray } from 'react-hook-form';
import React from 'react';
import Input from 'src/components/Input/Input';

const CloseIcon = ({ onClick = () => {} }) => {
  return (
    <span onClick={onClick} className={'cursor-pointer'}>
      <svg xmlns="http://www.w3.org/2000/svg" width="10" height="9" viewBox="0 0 10 9" fill="none">
        <path d="M1 0.5L9 8.5M9 0.5L1 8.5" stroke="#E50505" strokeLinecap="round" />
      </svg>
    </span>
  );
};

export const FreshdeskHelpCenterExcludedUrls = ({
  control,
  clearErrors = (..._args: any[]) => {},
}: {
  control?: any;
  clearErrors?: (...args: any[]) => void;
}) => {
  const { fields, append, remove } = useFieldArray({
    control,
    name: 'excluded_articles',
  });

  return (
    <div className={'flex flex-col w-full gap-2.5 p-2.5'}>
      {Boolean(fields.length) && (
        <ul className={'flex flex-col w-full gap-2.5'}>
          {fields.map((item, index) => (
            <li key={item.id} className={'flex flex-col w-full gap-[5px]'}>
              <div>
                <p
                  className={
                    'text-xs text-ebony_opacity_50 font-medium flex flex-row items-center justify-between'
                  }
                >
                  <span>{index + 1}. Excluded Url</span>
                  {<CloseIcon onClick={() => remove(index)} />}
                </p>
              </div>
              <div>
                <Controller
                  control={control}
                  name={`excluded_articles.${index}`}
                  render={({ field: { onChange, value }, fieldState: { error } }) => (
                    <Input
                      type={'text'}
                      placeholder={'https://www'}
                      invalidMessage={error?.message}
                      value={value}
                      isValid={!error?.message}
                      onChange={onChange}
                      onFocus={() => {
                        clearErrors(`excluded_articles.${index}`);
                      }}
                      className={'!py-2 !px-3.5'}
                    />
                  )}
                />
              </div>
            </li>
          ))}
        </ul>
      )}
      <div
        onClick={() => append('')}
        className={'text-[#7A6BE5] text-xs font-medium cursor-pointer hover:underline'}
      >
        Exclude specific article
      </div>
    </div>
  );
};
